<template>

  <div :class="{'box-loading': loading}">
    <div v-if="!edit">

      <div
        v-if="permissions.includes('manage_candidates')"
        class="dropdown"
        style="float:right">
        <button
          class="btn btn-sm btn-light"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          <i class="fas fa-chevron-down" />
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            class="dropdown-item"
            @click="editShare(share)">
              <i class="fas fa-pencil-alt" /> {{ $t('Edit') }}
            </button>
          <button
            class="dropdown-item"
            @click="deleteShare(share._id)">
              <i class="fas fa-times" /> {{ $t('Remove') }}
            </button>
        </div>
      </div>

      <div class="mb-3">
        <strong>{{ $tc('n_shared_candidates', share.candidates.length, { count: share.candidates.length }) }}</strong>
      </div>

      <div class="mb-3">
        <div class="mb-1"><strong>{{ $t('Show') }}:</strong> {{ sharePermissions }}</div>
        <input type="text" class="input-url form-control mt-2" :value="share.url">
      </div>

      <small>
        {{ $d(new Date(share.created_at), 'short') }}
        por {{ share.author_user_id.name }} - 
        <a href="" class="link-discreet">{{ share.job_id.title }}</a>
      </small>

    </div>

    <CandidateShareForm
      v-if="edit"
      :initValue="edit"
      @updated="updatedShare"
      @cancel="editCancel" />

  </div>

</template>

<script>
import CandidateShareForm from '../Share/CandidateShareForm'

export default {
  name: 'CandidateShareListItem',
  components: {
    CandidateShareForm
  },
  props: [
    'share'
  ],
  data () {
    return {
      loading: false,
      showAll: false,
      edit: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    sharePermissions () {
      let list = []

      if (this.share.permissions.contact) list.push(this.$t('Contact information'))
      if (this.share.permissions.salary) list.push(this.$t('Salary'))
      if (this.share.permissions.resume) list.push(this.$t('Resume (file)'))
      if (this.share.permissions.evaluations) list.push(this.$t('Evaluations'))
      if (this.share.permissions.intervideos) list.push(this.$t('Video interview'))
      if (this.share.permissions.questionnaires) list.push(this.$t('Questionnaires'))
      if (this.share.permissions.candidate_attachs) list.push(this.$t('Attachs'))
      if (this.share.permissions.add_evaluation) list.push(this.$t('Allow evaluation'))

      return list.join(', ')
    }
  },
  created () {
  },
  methods: {
    editShare (data) {
      this.edit = data
    },
    editCancel () {
      this.edit = false
    },
    updatedShare (share) {
      this.editCancel()
      this.$store.dispatch('refreshSelectActivities')
    },
    deleteShare (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteShareCandidate', id)
        .then((result) => {
          this.loading = false
          this.$store.dispatch('refreshSelectActivities')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-url {
  min-width: 160px;
  border: 0;
  background: rgba(0,0,0,0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Share/CandidateShareListItem.vue